export const SET_PARTNERS_FILTER = 'setPartnersFilter';
export const SET_PARTNERS_DATA = 'setPartnersData';
export const UPDATE_PARTNER_NOTES = 'updatePartnerNotes';
export const UPDATE_PARTNER_ACCOUNT_FIELDS = 'updatePartnerAccountFields';

export default {
  state: {
    filters: {
      search: '',
      statuses: [],
      owner: null,
      useAdvancedSearch: false,
      advancedSearch: false,
      isActiveMode: false,
    },
    partners: [],
    partnersById: {},
  },
  mutations: {
    [SET_PARTNERS_FILTER](state, payload) {
      state.filters = {
        ...state.filters,
        ...payload,
      };
    },
    [SET_PARTNERS_DATA](state, partners) {
      state.partners = partners;
      // Create a lookup map for quick access by partner account ID
      state.partnersById = partners.reduce((acc, partner) => {
        if (partner.account?.id) {
          acc[partner.account.id] = partner;
        }
        return acc;
      }, {});
    },
    [UPDATE_PARTNER_NOTES](state, { accountId, notes }) {
      // Update the partner in the partners array
      const partnerIndex = state.partners.findIndex(
        (partner) => partner.account?.id === accountId,
      );
      if (partnerIndex !== -1) {
        state.partners[partnerIndex].account.notes = notes;
      }

      // Update the partner in the lookup map
      if (state.partnersById[accountId]) {
        state.partnersById[accountId].account.notes = notes;
      }
    },
    [UPDATE_PARTNER_ACCOUNT_FIELDS](state, { accountId, fields }) {
      // Merge arbitrary account fields (e.g. taxId, vatId) so list-level
      // indicators like the "missing tax info" badge reflect edits immediately.
      const partnerIndex = state.partners.findIndex(
        (partner) => partner.account?.id === accountId,
      );
      if (partnerIndex !== -1) {
        Object.assign(state.partners[partnerIndex].account, fields);
      }

      if (state.partnersById[accountId]) {
        Object.assign(state.partnersById[accountId].account, fields);
      }
    },
  },
  getters: {
    getPartnerByAccountId: (state) => (accountId) => {
      return state.partnersById[accountId] || null;
    },
  },
};
